import React from 'react';
import { string, object, shape } from 'prop-types';

import { icons } from '../../icons';
import { VisuallyHiddenSpan } from './MacmillanLogoStyles';

const MacmillanLogo = (props) => {
  let { title } = props;
  const { brand: { short: brandShortName } } = props;

  // Return predictable className if none set
  const className = props.className !== '' ? props.className : `${brandShortName}Logo`;
  title = title || props.brand.full;
  return (
    <span className={className}>
      { className === 'footerLogo' ? icons[`${brandShortName}Footer`] : icons[brandShortName] }
      <VisuallyHiddenSpan aria-label={title}>{title}</VisuallyHiddenSpan>
    </span>
  );
};

export const logoList = Object.keys(icons);

MacmillanLogo.defaultProps = {
  className: '',
  title: '',
  style: {},
};
MacmillanLogo.listIcons = Object.keys(icons);

MacmillanLogo.propTypes = {
  title: string,
  style: object,
  className: string,
  brand: shape({
    short: string.isRequired,
    full: string.isRequired,
  }).isRequired,
};

export default MacmillanLogo;
